import type React from 'react';
import {
  PopoverContext,
  Popover as RACPopover,
  type PopoverProps as RACPopoverProps,
  composeRenderProps,
  useSlottedContext,
} from 'react-aria-components';
import { twMerge } from 'tailwind-merge';

export interface PopoverProps extends Omit<RACPopoverProps, 'children'> {
  children: React.ReactNode;
  plain?: boolean;
}

export function Popover({ children, className, plain = false, ...props }: PopoverProps) {
  const popoverContext = useSlottedContext(PopoverContext)!;
  const isSubmenu = popoverContext?.trigger === 'SubmenuTrigger';

  let offset = 8;
  offset = props.offset !== undefined ? props.offset : isSubmenu ? offset - 14 : offset;

  return (
    <RACPopover
      {...props}
      offset={offset}
      className={composeRenderProps(className, (className) => {
        return twMerge(
          'rounded-sm',
          !plain &&
            'bg-white shadow-md ring-1 ring-zinc-950/10 dark:bg-zinc-900 dark:ring-zinc-800',
          'entering:fade-in entering:placement-left:slide-in-from-right-1 entering:placement-right:slide-in-from-left-1 entering:placement-top:slide-in-from-bottom-1 entering:placement-bottom:slide-in-from-top-1 entering:animate-in entering:duration-50 ease-out',
          ' exiting:fade-out exiting:placement-left:slide-out-to-right-1 exiting:placement-right:slide-out-to-left-1 exiting:placement-top:slide-out-to-bottom-1 exiting:placement-bottom:slide-out-to-top-1 exiting:animate-out exiting:duration-50 exiting:ease-in',
          className,
        );
      })}
    >
      {children}
    </RACPopover>
  );
}
